import { render } from "./RegisterCustomerAccount.vue?vue&type=template&id=face7362&scoped=true"
import script from "./RegisterCustomerAccount.vue?vue&type=script&lang=js"
export * from "./RegisterCustomerAccount.vue?vue&type=script&lang=js"

import "./RegisterCustomerAccount.vue?vue&type=style&index=0&id=face7362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-face7362"]])

export default __exports__